module.exports = __webpack_public_path__ + "img/901480380.ca0d22fe.png";